<template>
  <section id="dashboard-ecommerce">
    <div>
      <configuration-view :pharmacien="userData" />
    </div>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import { ref } from '@vue/composition-api'
import router from '@/router'
import ConfigurationView from '../../components/pharmaciens/ConfigurationView.vue'
export default {
  components: {
    BRow,
    BCol,
    ConfigurationView,
  },
  data() {
    return {
      stats: {},
      data: {}
    }
  },
  methods: {
  },
  setup() {
    const userData = ref(null);
    userData.value = router.currentRoute.params.userData;
    return {
      userData,
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>




